import './Theme.Button.FileItem.scss';
export default 'ThemeButtonFileItem';
